var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState } from "react";
import { lifecycle } from "recompose";
import { PageLayout, withAnalytics, withLoadingSpinner, withMountTracking, withShowFlag, graphql, compose, } from "@atlassiansox/microscopekit";
import { withRouter } from "react-router-dom";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import serviceQuery from "../../drawers/service-creation/graphql/service-query.query.graphql";
import serviceWorkflowsDetailsQuery from "../../drawers/service-creation/graphql/service-workflows-details.query.graphql";
import WorkflowsTable from "./components/workflows-table";
var parse = require("query-string").parse;
var OperationsPageView = function (_a) {
    var serviceWorkflows = _a.serviceWorkflows, data = _a.data, location = _a.location, history = _a.history;
    var _b = useState({ date: new Date() }), state = _b[0], setState = _b[1];
    useEffect(function () {
        setState(__assign(__assign({}, state), { date: new Date() }));
        var interval = setInterval(function () { return setState(__assign(__assign({}, state), { date: new Date() })); }, 15000);
        return function () {
            clearInterval(interval);
        };
    });
    var qp = parse(location.search);
    var workflows = serviceWorkflows.service && serviceWorkflows.service.workflows ? __spreadArrays(serviceWorkflows.service.workflows) : [];
    return (React.createElement("div", null,
        React.createElement(PageLayout, { title: "Platform Operational Layer" },
            React.createElement(WorkflowsTable, { workflows: workflows, isLoading: serviceWorkflows.loading, workflowId: typeof qp.workflowId === 'string' ? qp.workflowId : undefined, date: state.date, history: history, service: data.service }))));
};
export var OperationsPage = compose(graphql(serviceQuery, {}), graphql(serviceWorkflowsDetailsQuery, {
    name: "serviceWorkflows",
    options: function (props) { return ({
        query: serviceWorkflowsDetailsQuery,
        variables: { id: props.id },
        pollInterval: 10000
    }); }
}), withAnalytics, withLoadingSpinner, withShowFlag, withServiceNotFoundHandler, withRouter, withMountTracking('Operations.OperationsPage'), lifecycle({
    componentDidMount: function () {
        var qp = parse(this.props.location.search);
        if (qp.workflowId && !this.props.serviceWorkflows.loading) {
            this.props.serviceWorkflows.refetch();
        }
    }
}))(OperationsPageView);
